<template>
    <div class="field__calendar">
        <date-picker
            v-model="date"
            value=""
            color="teal"
            locale="pt"
            title-position="left"
            is-expanded
            :masks="mask"
            @input="action"
            v-bind="{
                ...( configs.mode && { mode: configs.mode }),
                ...( configs.minDate && { 'min-date': configs.minDate }),
                ...( configs.maxDate && { 'max-date': configs.maxDate }),
                ...( configs.is24hr && { is24hr: configs.is24hr, 'minute-increment': 5 })
            }"
        >
            <template v-if="!configs.hideInput" v-slot="{ inputValue, inputEvents }">
                <input
                    v-bind="{...$attrs }"
                    :class="targetClass"
                    :value="inputValue"
                    v-on="inputEvents"
                />
            </template>
        </date-picker>
    </div>
</template>

<script>
// packages
import { ref, computed } from '@vue/composition-api';

// hooks
import { reset } from '@/hooks/use-input-listeners';

// componentes
import { DatePicker, Locale } from 'v-calendar';

// utils
import { haveProperty } from '@/utils/';

// definições das datas.
const locale = new Locale();
const defaultFormat = 'YYYY-MM-DD';

export default {
    inheritAttrs: false,
    components: {
        DatePicker
    },
    props: {
        targetClass: String,
        reset: Boolean,
        defaultValue: String,
        configs: {
            type: Object,
            default: () => ({})
        }
    },
    setup ( props, { emit }) {
        const dateString = ref( props.defaultValue );
        const format = props.configs?.format || defaultFormat;
        const mask = { input: format };

        // listener para quando for necessário
        // proceder a um reset a input.
        reset({
            props,
            object: dateString,
            key: 'value'
        });

        /**
         * Formatação da data.
         *
         * @param {String/Date} date
         * @param {String} type - parse / formate
         * @since 1.0.0
         * @category Method
         * @autor Tiago Martinho
         *
        */
        const formatDate = ( date, type ) => locale[type]( date, format );

        // formatação da data.
        const date = computed({
            get: () => ( dateString.value ? formatDate( dateString.value, 'parse' ) : null ),
            set: newDate => {
                dateString.value = newDate ? formatDate( newDate, 'format' ) : '';
            }
        });

        // emite o valor para o compomente pai.
        const action = () => {
            emit( 'input', dateString.value );
        };

        return {
            date,
            mask,
            action,
            haveProperty
        };
    }
};
</script>